<template lang="pug">
  .floating-box(:class="{ hidden: isScrolling }" @click="goBack()" v-if="env.isEasyBikeApp")
    img(src="https://m.hellobike.com/resource/gallery/61/BNC9qLIlTz.png?x-oss-process=image/quality,q_80")
</template>

<script>
import { Navigator } from '@hb/h5-navigator';
import config from '@/const/config';
import { env } from '@hb/NBridge/lib/h5';

export default {
  data() {
    return {
      env,
      isScrolling: false,
      scrollTimer: null,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    if (this.scrollTimer) {
      clearTimeout(this.scrollTimer);
      this.scrollTimer = null;
    }
    this.isScrolling = null;
  },
  methods: {
    handleScroll() {
      this.isScrolling = true;
      clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => {
        this.isScrolling = false;
      }, 300);
    },
    goBack() {
      Navigator.go(`https://m.hellobike.com/AppOperateH5/${config.env === 'pro' ? '' : `${config.env}/`}latest/index.html#/giftCard`);
    },
  },

};
</script>

<style lang="less" scoped>
.floating-box {
  position: fixed;
  bottom: 0.44rem;
  left: 0.04rem;
  color: white;
  width: 0.6rem;
  height: 0.6rem;
  transition: transform 0.3s ease;

  img {
    width: 0.6rem;
    height: 0.6rem;
  }

  &.hidden {
    transform: translateX(-60%);
    opacity: 0.5;
  }
}
</style>
